import React from 'react';
import { Shield, Clock, Award, Users, Wrench, ThumbsUp } from 'lucide-react';

export const WhyChooseUsSection = () => {
  const reasons = [
    {
      icon: Shield,
      title: 'Durable Materials',
      description: 'We use quality materials suited to Australian weather conditions for long-lasting protection.'
    },
    {
      icon: Clock,
      title: 'Fast Response',
      description: 'Quick turnaround times and same-day emergency service when you need it most.'
    },
    {
      icon: Award,
      title: 'Quality Workmanship',
      description: 'Professional installation with attention to finish, performance, and durability.'
    },
    {
      icon: Users,
      title: 'Local Experts',
      description: 'Greater Sydney based team who understand local conditions and building requirements.'
    },
    {
      icon: Wrench,
      title: 'Full Service',
      description: 'From inspections to installations, repairs to replacements - we handle it all.'
    },
    {
      icon: ThumbsUp,
      title: 'Free Quotes',
      description: 'No-obligation inspections and honest advice on the best solution for your home.'
    }
  ];

  return (
    <section className="section-padding bg-gray-50" data-testid="why-choose-us-section">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-primary">Dezire Metal Roofing?</span>
          </h2>
          <p className="text-lg text-gray-600">
            Metal roofing is a strong choice for Sydney homes because it offers durability, low maintenance, and reliable protection against harsh weather.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300"
              data-testid={`why-choose-item-${index}`}
            >
              <div className="w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                <reason.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{reason.title}</h3>
              <p className="text-gray-600">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
